// extracted by mini-css-extract-plugin
export default {"logo":"details_logo__5LC75"};